import axios from 'axios';

// Create an axios instance with default configuration
const api = axios.create({
    // baseURL: 'http://127.0.0.1:8000/api', // Fixed IP address format
    baseURL: 'https://api.cliniquemoulouya.ma/api',
    timeout: 5000, 
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor
api.interceptors.request.use(
    (config) => {
        // You can add authentication headers or other request modifications here
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle errors globally
        return Promise.reject(error);
    }
);

// Contact API functions
export const sendContactData = async (contactData) => {
    try {
        const response = await api.post('/contacts', contactData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getStatisticsData = async () => {
    try {
        const response = await api.get('/statistics');
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const fetchVideos = async () => {

        try { 
            const response = await api.get(
                '/videos/true'
            );
            
            if (!response.data ) {
                console.warn("La réponse de l'API Instagram est vide ou incorrecte.");
                return []; 
            }
    
            const allMedia = Array.isArray(response.data) 
            ? response.data 
            : Object.values(response.data);
    
            return allMedia;
        } catch (error) {
            console.error('Error fetching videos:', error);
            return []; 
        }
};
export const fetchGalrieVideos = async () => {
    try { 
        const response = await api.get(
            '/videos/false'
        );
        
        if (!response.data) {
            console.warn("La réponse de l'API Instagram est vide ou incorrecte.");
            return []; 
        }
        

        const allMedia = Array.isArray(response.data) 
        ? response.data 
        : Object.values(response.data);

        return allMedia;
    } catch (error) {
        console.error('Error fetching videos:', error);
        return []; 
    }
};
export default api;
